import { CHANNEL_STATUS, IChannel, PROTOCOL } from '@/entities/channel';

type MaxPersonalConnectionSource = Pick<IChannel, 'protocol' | 'status'>;

export const canDeleteMaxPersonalConnection = (
  channel: MaxPersonalConnectionSource
) =>
  channel.protocol === PROTOCOL.MAX_PERSONAL &&
  channel.status !== CHANNEL_STATUS.UNAUTHORIZED;
